// AWS Amplify v6 Configuration
export default {
  Auth: {
    Cognito: {
      region: "us-east-1",
      userPoolId: "us-east-1_zlnSSHEvs",
      userPoolClientId: "67a5li1129kf7d3qvmllphbqks",
      loginWith: {
        email: true
      }
    }
  }
};